"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const formatUtils_1 = require("../../helpers/formatUtils");
/**
 * An OutlinedInput formatted to display dollar currency values correctly
 *
 * Please feel free to add additional features - reach out to [#mosaic](slack://channel?team=T02835DET&id=CE299KC1X) for any help or guidance.
 */
const CurrencyInput = (_a) => {
    var { valueCents, onValueChange, disabled, placeholder = '$100,000', roundToCents } = _a, rest = __rest(_a, ["valueCents", "onValueChange", "disabled", "placeholder", "roundToCents"]);
    const onInputChange = (event) => {
        const value = event.target.value;
        // Removes '$' and ',' characters from the value string in order to parse value as a number
        const numValue = parseInt(value.replace(/\$|\,|\./g, ''));
        const isNumeric = !isNaN(numValue);
        /** Calls onChange with an undefined value to ensure placeholder is shown when
         *  all inputdoes not display last previously acceptable numeric value
         */
        onValueChange(isNumeric ? numValue * 100 : undefined);
    };
    return (react_1.default.createElement(core_1.OutlinedInput, Object.assign({ disabled: disabled, placeholder: disabled ? undefined : placeholder, value: valueCents && formatUtils_1.centsToCurrencyString(valueCents, roundToCents), onChange: onInputChange }, rest)));
};
exports.default = CurrencyInput;
